import React, { useState, useEffect, useRef } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import Tooltip from "@mui/material/Tooltip";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../../lib/axios";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
const TicketStatus = () => {
  const [formData, setFormData] = useState({
    ticketNo: "",
    mobileNo: "",
  });

  const [error, setError] = useState({
    ticketNo: false,
    mobileNo: false,
  });

  const [searchResults, setSearchResults] = useState(null);
  const [activeStep, setActiveStep] = useState(0);
  const [showHistoryTable, setShowHistoryTable] = useState(false);
  const navigate = useNavigate();

  const ticketNoRef = useRef(null);
  const mobileNoRef = useRef(null);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const handleSearch = async () => {
    let hasError = false;

    // Basic validation
    if (!formData.ticketNo && !formData.mobileNo) {
      toast.error("Please enter either a Ticket No. or Mobile No.");
      hasError = true;
    }

    if (hasError) {
      return;
    }

    try {
      const searchParams = {
        ticketNo: formData.ticketNo || "",
        emailId: formData.emailId || "",
      };

      const response = await axiosInstance.post("Ticket/Search", searchParams);

      const {
        data: { Status, Message, Data, responseStatusCode },
      } = response;

      if (Status === 0 && responseStatusCode === 1) {
        setSearchResults(Data);
        toast.success("Search successful");
        setActiveStep(1);
      } else {
        toast.error(Message || "No records found");
        setActiveStep(0);
      }
    } catch (error) {
      console.error("Error performing search:", error);
      toast.error("Error performing search. Please try again.");
    }
  };

  const handleViewDetails = (ticketId) => {
    navigate(`/ticket-details/${ticketId}`);
  };

  const steps = ["Open", "Inprogress", "Resolved"];

  const toggleHistoryTable = () => {
    setShowHistoryTable((prevState) => !prevState);
  };

  const ticketHistory = [
    {
      ticketno: "1234",
      status: "Open",
      dateTime: "2024-12-30 10:00 AM",
      description: "abc",
    },
    {
      ticketno: "1234",
      status: "Inprogress",
      dateTime: "2024-12-30 02:00 PM",
      description: "abc",
    },
    {
      ticketno: "1234",
      status: "Resolved",
      dateTime: "2024-12-30 05:00 PM",
      description: "abc",
    },
  ];

  const getStepColor = (status) => {
    if (status === "Open") return "#ff0000";
    if (status === "Inprogress") return "#2196f3";
    return "#4caf50";
  };

  const getTableRowColor = (status) => {
    if (status === "Open") return "#ffebee"; // Light Red for Open
    if (status === "Inprogress") return "#e3f2fd"; // Light Blue for Inprogress
    return "#e8f5e9"; // Light Green for Resolved
  };

  return (
    <>
      <Box className="form-container">
        <ToastContainer />
        <Grid container spacing={2} className="form_grid">
          <Grid
            container
            spacing={2}
            className="form_grid"
            sx={{ marginTop: "20px" }}
          >
            <Grid
              item
              xs={12}
              className="form_title"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <h3>Find Your Ticket Status/History</h3>
            </Grid>

            <Grid
              item
              xs={12}
              className="form_field"
              sx={{ display: "flex", alignItems: "center", gap: 2 }}
            >
              <TextField
                id="ticketNo"
                name="ticketNo"
                label="Ticket No."
                variant="filled"
                fullWidth
                value={formData.ticketNo}
                onChange={handleInputChange}
                onKeyDown={handleKeyPress}
                error={error.ticketNo}
                helperText={error.ticketNo && "Ticket No. is required"}
                inputRef={ticketNoRef}
                sx={{ flex: 2 }}
              />
              <span>OR</span>
              <TextField
                id="mobileno"
                name="mobileNo"
                label="Mobile No."
                variant="filled"
                fullWidth
                value={formData.mobileNo}
                onChange={handleInputChange}
                onKeyDown={handleKeyPress}
                error={error.mobileNo}
                helperText={error.mobileNo && "Mobile No. is required"}
                inputRef={mobileNoRef}
                sx={{ flex: 2 }}
              />
              <Button
                variant="contained"
                onClick={handleSearch}
                sx={{ padding: "8px 16px" }}
              >
                <SearchIcon />
                Search
              </Button>
            </Grid>
          </Grid>

          {searchResults && (
            <Grid item xs={12}>
              <Box sx={{ marginTop: "20px" }}>
                <h4>Search Results</h4>
                {searchResults.length > 0 ? (
                  <ul>
                    {searchResults.map((ticket) => (
                      <li key={ticket.ticketId}>
                        Ticket No: {ticket.ticketNo} | Mobile: {ticket.mobileNo}
                        <Button
                          variant="outlined"
                          sx={{ marginLeft: "10px" }}
                          onClick={() => handleViewDetails(ticket.mobileNo)}
                        >
                          View Details
                        </Button>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>No results found</p>
                )}
              </Box>
            </Grid>
          )}

          {/* Stepper */}
          <Grid
            item
            xs={12}
            sx={{
              marginTop: "20px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Stepper activeStep={activeStep} alternativeLabel sx={{ flex: 1 }}>
              {steps.map((label, index) => {
                // Determine step color based on the activeStep state
                const stepColor =
                  activeStep === index
                    ? index === 0
                      ? "red"
                      : index === 1
                      ? "#2196f3"
                      : "#4caf50"
                    : "#dcdcdc"; 

                return (
                  <Step key={label}>
                    <StepLabel
                      sx={{
                        color: stepColor, 
                        fontWeight: "bold", 
                        "& .MuiStepIcon-root": {
                          color: stepColor,
                        },
                        "& .MuiStepLabel-active .MuiStepIcon-root": {
                          color: stepColor, 
                        },
                        "& .MuiStepLabel-completed .MuiStepIcon-root": {
                          color: stepColor, 
                        },
                      }}
                    >
                      {label}
                    </StepLabel>
                  </Step>
                );
              })}
            </Stepper>

            <Tooltip title="Click to show/hide the ticket history">
              <Button
                variant="outlined"
                onClick={toggleHistoryTable}
                startIcon={<AddIcon sx={{ fontSize: "20px" }} />}
                sx={{
                  marginRight: "100px",
                  borderRadius: "50%",
                  paddingRight: "5px",
                  minWidth: "20px",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                }}
              />
            </Tooltip>
          </Grid>

          {/* MUI Table with Improved Styling */}
          <Grid item xs={12} sx={{ marginTop: "20px", ml: "20px" }}>
            {showHistoryTable && (
              <Box sx={{ marginTop: "20px" }}>
                <h4>Ticket History</h4>
                <TableContainer component={Paper} sx={{ boxShadow: 3 }}>
                  <Table
                    sx={{ minWidth: 650 }}
                    aria-label="ticket history table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            backgroundColor: "#f4f4f4",
                          }}
                        >
                          Ticket No.
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            backgroundColor: "#f4f4f4",
                          }}
                        >
                          Date & Time
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            backgroundColor: "#f4f4f4",
                          }}
                        >
                          Status
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            backgroundColor: "#f4f4f4",
                          }}
                        >
                          Description
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {ticketHistory.map((history, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            backgroundColor: getTableRowColor(history.status),
                            "&:hover": {
                              backgroundColor: "#f1f1f1",
                            },
                          }}
                        >
                          <TableCell sx={{ padding: "8px 16px" }}>
                            {history.ticketno}
                          </TableCell>
                          <TableCell sx={{ padding: "8px 16px" }}>
                            {history.dateTime}
                          </TableCell>
                          <TableCell sx={{ padding: "8px 16px" }}>
                            {history.status}
                          </TableCell>
                          <TableCell sx={{ padding: "8px 16px" }}>
                            {history.description}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default TicketStatus;
